import OfferingsSection from "./OfferingsSection/OfferingsSection";
import FAQSection from "./FAQSection/FAQSection";
import PartnersSection from "./PartnersSection/PartnersSection";
import NewsSection from "./NewsSection/NewsSection";
import AboutSection from "./AboutSection/AboutSection";
import HeroSection from "./HeroSection/HeroSection";

const FrontPage = () => {
  return (
    <>
      <div style={{ overflowX: "hidden" }}>
        <HeroSection />
        <AboutSection />
        <OfferingsSection />
        <FAQSection />
        <NewsSection />
        <PartnersSection />
      </div>
    </>
  );
};

export default FrontPage;
